import React, {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const copy = {
  en: {
    title: 'Invitations',
    helper: 'Invite new associates and keep access requests organized.',
    invite: 'Invite new associate',
    name: 'Name',
    email: 'Email address',
    language: 'Preferred language',
    country: 'Country',
    role: 'Role',
    note: 'Personal note',
    send: 'Send invitation',
    pending: 'Pending',
    accepted: 'Accepted',
    expired: 'Expired',
    sent: 'Sent',
    invitedBy: 'Invited by',
    resend: 'Resend',
    revoke: 'Revoke',
    sentToast: 'Invitation sent successfully.',
    resentToast: 'Invitation resent successfully.',
    revokedToast: 'Invitation revoked.',
    required: 'This field is required.',
    noInvites: 'No invitations have been sent yet.'
  },
  es: {
    title: 'Invitaciones',
    helper: 'Invita a nuevos asociados y organiza las solicitudes de acceso.',
    invite: 'Invitar nuevo asociado',
    name: 'Nombre',
    email: 'Correo electrónico',
    language: 'Idioma preferido',
    country: 'País',
    role: 'Rol',
    note: 'Nota personal',
    send: 'Enviar invitación',
    pending: 'Pendiente',
    accepted: 'Aceptada',
    expired: 'Vencida',
    sent: 'Enviada',
    invitedBy: 'Invitado por',
    resend: 'Reenviar',
    revoke: 'Revocar',
    sentToast: 'La invitación se envió correctamente.',
    resentToast: 'La invitación se reenvió correctamente.',
    revokedToast: 'La invitación fue revocada.',
    required: 'Este campo es obligatorio.',
    noInvites: 'Aún no se han enviado invitaciones.'
  }
};

function InvitationsPage({user, language, invitations, onSend, onResend, onRevoke}) {
  const [form, setForm] = useState({name: '', email: '', language: 'EN', country: '', role: 'agent', note: ''});
  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState('');
  const text = copy[language];
  const roles = user.role === 'recruiter' ? ['agent'] : ['agent', 'recruiter', 'trainer', 'admin'];

  const notify = (message) => {
    setToast(message);
    window.setTimeout(() => setToast(''), 2600);
  };

  const submit = (event) => {
    event.preventDefault();
    const nextErrors = {};
    ['name', 'email', 'country'].forEach((key) => {
      if (!form[key].trim()) nextErrors[key] = true;
    });
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;
    onSend({...form, invitedBy: user.name});
    setForm({name: '', email: '', language: 'EN', country: '', role: 'agent', note: ''});
    notify(text.sentToast);
  };

  return <div className="page-content invitations-page">
    <div className="page-title">
      <span className="eyebrow">GFI INTERNATIONAL</span>
      <h1>{text.title}</h1>
      <p>{text.helper}</p>
    </div>

    <div className="invitation-layout">
      <form className="invite-form" onSubmit={submit}>
        <div className="form-heading">
          <span><SafeIcon icon={FiIcons.FiUserPlus} /></span>
          <div><h2>{text.invite}</h2><p>Local demo data only</p></div>
        </div>
        <label>{text.name}<input value={form.name} onChange={(event) => setForm({...form, name: event.target.value})} />{errors.name && <em>{text.required}</em>}</label>
        <label>{text.email}<input type="email" value={form.email} onChange={(event) => setForm({...form, email: event.target.value})} />{errors.email && <em>{text.required}</em>}</label>
        <div className="form-two-columns">
          <label>{text.language}<select value={form.language} onChange={(event) => setForm({...form, language: event.target.value})}><option>EN</option><option>ES</option></select></label>
          <label>{text.country}<input value={form.country} onChange={(event) => setForm({...form, country: event.target.value})} />{errors.country && <em>{text.required}</em>}</label>
        </div>
        <label>{text.role}<select value={form.role} onChange={(event) => setForm({...form, role: event.target.value})}>{roles.map((role) => <option key={role} value={role}>{role}</option>)}</select></label>
        <label>{text.note}<textarea rows="3" value={form.note} onChange={(event) => setForm({...form, note: event.target.value})} /></label>
        <button className="primary-button" type="submit"><SafeIcon icon={FiIcons.FiSend} />{text.send}</button>
      </form>

      <section className="invitation-list-card">
        <div className="section-heading"><div><h2>{text.title}</h2><p>{invitations.length}</p></div></div>
        <div className="invitation-list">
          {invitations.length ? invitations.map((item) => <article className="invitation-row" key={item.id}>
            <span className="invite-avatar">{item.name.split(' ').map((part) => part[0]).join('').slice(0, 2)}</span>
            <div className="invitation-person"><strong>{item.name}</strong><small>{item.email}</small><small>{text.invitedBy}: {item.invitedBy} · {text.sent} {item.sentAt}</small></div>
            <span className={`invite-status ${item.status}`}>{text[item.status]}</span>
            <div className="invitation-actions">
              <button type="button" onClick={() => {onResend(item.id); notify(text.resentToast);}}><SafeIcon icon={FiIcons.FiRefreshCw} />{text.resend}</button>
              {item.status === 'pending' && <button type="button" onClick={() => {onRevoke(item.id); notify(text.revokedToast);}}>{text.revoke}</button>}
            </div>
          </article>) : <div className="content-empty">{text.noInvites}</div>}
        </div>
      </section>
    </div>
    {toast && <div className="admin-toast" role="status"><SafeIcon icon={FiIcons.FiCheckCircle} />{toast}</div>}
  </div>;
}

export default InvitationsPage;